import { Component, inject, OnInit } from '@angular/core'
import {
  ActivatedRoute,
  Router,
  RouterModule,
  RouterOutlet,
} from '@angular/router'
import { Menubar } from 'primeng/menubar'
import { InputTextModule } from 'primeng/inputtext'
import { RippleModule } from 'primeng/ripple'
import { CommonModule } from '@angular/common'
import { MenuItem } from 'primeng/api'
import { MenuModule } from 'primeng/menu'
import { ButtonModule } from 'primeng/button'
import { Actions, Store } from '@ngxs/store'
import { Logout } from '../../../core/stores/auth/auth.actions'
import { AuthState } from '../../../core/stores/auth/auth.state'
import { NewModalComponent } from '../../events/components/new-modal/new-modal.component'

@Component({
  selector: 'app-authenticated-layout',
  standalone: true,
  imports: [
    Menubar,
    InputTextModule,
    RippleModule,
    CommonModule,
    RouterOutlet,
    RouterModule,
    MenuModule,
    ButtonModule,
  ],
  templateUrl: './authenticated-layout.component.html',
  styleUrl: './authenticated-layout.component.scss',
})
export class AuthenticatedLayoutComponent implements OnInit {
  public items: MenuItem[] = [
    {
      label: 'Calendrier',
      icon: 'pi pi-calendar',
      path: '/calendar',
      newTab: true,
    },
    {
      label: 'Utilisateurs',
      icon: 'pi pi-users',
      path: '/users',
      newTab: false,
    },
    {
      label: 'A programmer',
      icon: 'pi pi-clock',
      path: '/products-to-planify',
      newTab: false,
    },
    {
      label: 'A venir',
      icon: 'pi pi-calendar',
      path: '/interventions-incoming',
      newTab: false,
    },
    {
      label: 'A replanifier',
      icon: 'pi pi-calendar-clock',
      path: '/interventions-to-reschedule',
      newTab: false,
    },
    {
      label: 'Optimisation',
      icon: 'pi pi-list',
      path: '/optimization',
      newTab: false,
    },
    {
      label: 'Programmator',
      icon: 'pi pi-list',
      path: '/pool-optimization',
      newTab: false,
    },
    {
      label: 'Admin',
      icon: 'pi pi-cog',
      items: [
        {
          label: 'Jobs',
          icon: 'pi pi-server',
          path: '/admin/jobs',
          newTab: false,
        },
        {
          label: 'Webhooks',
          icon: 'pi pi-bolt',
          path: '/admin/webhooks',
          newTab: false,
        },
        {
          label: 'Debug optimisation',
          icon: 'pi pi-search',
          path: '/admin/optimization-debug',
          newTab: false,
        },
        {
          label: 'Diagnostique',
          icon: 'pi pi-exclamation-circle',
          path: '/admin/optimization-diagnostic',
          newTab: false,
        },
        {
          label: 'Logs',
          icon: 'pi pi-file-edit',
          path: '/admin/logs',
          newTab: false,
        },
        {
          label: 'Paramètres Tablot',
          icon: 'pi pi-sliders-h',
          path: '/admin/tablot-settings',
          newTab: false,
        },
        {
          label: 'Test routabilité',
          icon: 'pi pi-map-marker',
          path: '/admin/routability-test',
          newTab: false,
        },
        {
          label: 'Secteurs',
          icon: 'pi pi-map',
          path: '/admin/sectors',
          newTab: false,
        },
      ],
    },
  ]

  public activeLabel: string | undefined

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store
  ) {}

  logout(): void {
    this.store.dispatch(new Logout()).subscribe(() => {
      this.router.navigate(['/login'])
    })
  }

  ngOnInit() {
    const roles = this.store.selectSnapshot(AuthState.getRoles)
    if (!roles.includes('administrator')) {
      this.items = this.items.filter((item) => item.label !== 'Admin')
    }

    this.items.forEach((item) => {
      if (this.router.url.includes(item['path'])) {
        this.activeLabel = item.label
      }
    })
  }
}
